import { SET_SEARCH_RESULTS, ActionSearchResultsTypes } from './actions';
import { SearchResultsQuery } from '@websky/graphql';

const initialState: SearchResultsQuery['SearchResult'] = null;

function searchResultsReducer(state = initialState, { type, payload }: ActionSearchResultsTypes) {
	switch (type) {
		case SET_SEARCH_RESULTS: {
			return payload;
		}

		default: {
			return state;
		}
	}
}

export default searchResultsReducer;
